import React from 'react';
import ChevronDoubleRight from 'assets/svg/ChevronDoubleRight';

interface Props {
    title: string;
    //  right opens the applied-filters pane, left goes back to the filter list
    direction: 'right' | 'left';
    onArrowClick: () => void;
}

const FilterV2Header = ({ title, direction, onArrowClick }: Props) => (
    <div className="flex justify-between items-center px-4">
        <span className="font-sm font-medium leading-[normal] text-filterV2TextPrimary">{title}</span>
        <span
            role="button"
            className="w-6 h-6 flex justify-center items-center border border-filterV2Border rounded cursor-pointer"
            onClick={() => onArrowClick()}
        >
            <ChevronDoubleRight direction={direction} size={18} />
        </span>
    </div>
);

export default FilterV2Header;
